import React, { useState } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Divider,
  Typography
} from '@material-ui/core';
import AddedProducts from './AddedProducts';

const DealsPicker = ({ value, onChange }) => {
  const [viewOpen, setViewOpen] = useState(false);

  return (
    <Box display="flex" alignItems="center" gridGap={8}>
      <TextField
        fullWidth
        variant="outlined"
        label="Set Deals"
        onClick={() => setViewOpen(true)}
        readOnly
      />

      <Dialog
        open={viewOpen}
        onClose={() => setViewOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          <Box>
            <Typography variant="h4">Deal's Package</Typography>
            <Typography variant="h6" color="textSecondary">
              You can choose or select your deals
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <AddedProducts value={value} onChange={onChange} />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setViewOpen(false)}
            color="primary"
            variant="contained"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DealsPicker;
